<!-- 教育背景 -->
<template>
  <div class="education">
    <h1 class="application-title">上传信息搜集表</h1>
    <Row :gutter="10">
        <Col span="24" class="dis_15 icon_color">
          <span class="upload-title">再来人CV及网申信息表：</span>
          <template v-if="!personalFile || !personalFile.cvInfoUrl">
            <Button type="ghost"
                    icon="ios-cloud-upload-outline"
                     v-if="isallowedit"
                    @click="handleUploadModal('cv')">
              <slot name="button-content"><span class="upload-file">上传</span></slot>
            </Button>
          </template>
          <template v-else>
            <Button type="ghost"
                    icon="ios-cloud-download-outline"
                    @click="download(personalFile.cvInfoUrl)">
              <slot name="button-content"><span class="upload-file">下载</span></slot>
            </Button>
            <Button type="warning"
                    icon="ios-cloud-upload-outline"
                    class="update_btn"
                    @click="handleUploadModal('cv')">
              <slot name="button-content"><span>更新</span></slot>
            </Button>
          </template>
        </Col>
        <Col span="24" class="dis_15 icon_color">
            <span class="upload-title">再来人推荐信信息采集表：</span>
            <template v-if="!personalFile || !personalFile.rlInfoUrl">
                <Button type="ghost"
                        icon="ios-cloud-upload-outline"
                        v-if="isallowedit"
                        @click="handleUploadModal('rl')">
                  <slot name="button-content"><span class="upload-file">上传</span></slot>
                </Button>
            </template>
            <template v-else>
              <Button type="ghost"
                      icon="ios-cloud-download-outline"
                      @click="download(personalFile.rlInfoUrl)">
                <slot name="button-content"><span class="upload-file">下载</span></slot>
              </Button>
              <Button type="warning"
                      icon="ios-cloud-upload-outline"
                      class="update_btn"
                      @click="handleUploadModal('rl')">
                <slot name="button-content"><span>更新</span></slot>
              </Button>
            </template>
          </Col>
          <Col span="24" class="dis_15 icon_color">
            <span class="upload-title">PS Outline Template - for SM PS Brainstorming：</span>
            <template v-if="!personalFile || !personalFile.psInfoUrl">
                <Button type="ghost"
                        icon="ios-cloud-upload-outline"
                        v-if="isallowedit"
                        @click="handleUploadModal('ps')">
                  <slot name="button-content"><span class="upload-file">上传</span></slot>
                </Button>
            </template>
            <template v-else>
              <Button type="ghost"
                      icon="ios-cloud-download-outline"
                      @click="download(personalFile.psInfoUrl)">
                <slot name="button-content"><span class="upload-file">下载</span></slot>
              </Button>
              <Button type="warning"
                      icon="ios-cloud-upload-outline"
                      class="update_btn"
                      @click="handleUploadModal('ps')">
                <slot name="button-content"><span>更新</span></slot>
              </Button>
            </template>
          </Col>
    </Row>
    <zlr-modal v-model="uploadModal">
      <div class="upload-modal-box">
          <Form  ref="formValidate"
                :model="formValidate">
                <upload :path="`expert/${type}_info`"
                        ref="upload"
                        v-model="formValidate.url"
                        @on-success='upSuccess'></upload>
                <div class="upload-btn-box">
                  <Button class="close-btn"
                          @click="handleCloseModal">关闭</Button>
                  <Button type="primary"
                          @click="handleSubModal">确认上传</Button>
                </div>
          </Form>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// less
import './application.less'
// components
import ZlrModal from '_c/modal/modal'
import Upload from '_c/upload/upload'
import { ossSecretLink } from '@/api/oss'
import { getInfoApplicationFile, infoUploadPS, infoUploadCV, infoUploadRL } from '@/api/info'
import isAllowEdit from '@/view/mixins/is-edit'

export default {
  name: 'application-upload-info',
  mixins: [isAllowEdit],
  components: {
    Upload,
    ZlrModal
  },
  data () {
    return {
      personalFile: {
        cvInfoUrl: '',
        rlInfoUrl: '',
        psInfoUrl: ''
      },
      formValidate: {
        url: ''
      },
      uploadModal: false,
      type: ''
    }
  },
  computed: {},
  mounted () {
    this.getInfoFile()
  },
  methods: {
    getInfoFile () {
      getInfoApplicationFile().then(res => {
        if (res.code === 0) {
          let data = res.data.model || {}
          this.personalFile = Object.assign({}, data)
        }
      })
    },
    // 下载
    download (url) {
      ossSecretLink({
        dir: url
      }).then(res => {
        window.open(res.data.url)
      })
    },
    // 上传成功
    upSuccess (file) {
      if (file.size === 0) {
        this.$zlr_message('无法上传空文件', 'error')
      }
    },
    // 重置数据
    resetData () {
      this.$set(this.formValidate, 'url', '')
    },
    // 打开弹窗
    handleUploadModal (type) {
      this.type = type
      this.uploadModal = true
    },
    // 关闭弹窗
    handleCloseModal () {
      this.uploadModal = false
      this.resetData()
    },
    // 确认上传更新
    handleSubModal () {
      let url = this.formValidate.url
      let type = this.type
      if (type === 'cv') {
        infoUploadCV({ key: url }).then(res => {
          if (res.code === 0) {
            this.$zlr_message('上传成功', 'success')
            this.getInfoFile()
            this.handleCloseModal()
          } else {
            this.$zlr_message('上传失败', 'error')
          }
        })
      } else if (type === 'rl') {
        infoUploadRL({ key: url }).then(res => {
          if (res.code === 0) {
            this.$zlr_message('上传成功', 'success')
            this.getInfoFile()
            this.handleCloseModal()
          } else {
            this.$zlr_message('上传失败', 'error')
          }
        })
      } else if (type === 'ps') {
        infoUploadPS({ key: url }).then(res => {
          if (res.code === 0) {
            this.$zlr_message('上传成功', 'success')
            this.getInfoFile()
            this.handleCloseModal()
          } else {
            this.$zlr_message('上传失败', 'error')
          }
        })
      } else {

      }
    }
  }
}
</script>
<style lang='less' scoped>
.dis_15{
  margin-bottom: 10px;
}
.upload-title {
  display: inline-block;
  font-weight: bold;
  margin-bottom:20px;
}
.upload-file {
  display: inline-block;
  cursor: pointer;
  color: #6589dd;
}
.update_btn{
  margin-left:20px;
}
.upload-modal-box{
  padding:50px 0;
}
.upload-btn-box{
  margin-top:30px;
  text-align: center;
}
.upload-btn-box .close-btn{
  margin-right:20px;
}
</style>
<style lang="less">
.icon_color .ivu-btn>.ivu-icon{
  color:#6589dd;
}
.update_btn.ivu-btn>.ivu-icon{
  color:#ffffff;
}
</style>
